module.exports = __webpack_public_path__ + "static/media/experience-strict-hygiene.559ec173.webp";